module.exports = __webpack_public_path__ + "static/media/CG.e6f61257.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CG.svg
// module id = 2127
// module chunks = 7